import React from 'react';
import { useTranslation } from 'react-i18next';
import { Callout } from '@blueprintjs/core';
import FormButtons from 'components/FormButtons';
import { FormLayout, FormLayoutContent } from 'components/FormLayout';
import FormPanel from 'components/FormPanel';
import './warrant-missing-templates.scss';

type Props = {
  title: string
  onClickCancelClose: () => void
}

const WarrantMissingTemplates = ({
  title,
  onClickCancelClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="warrant warrant-missing-template" data-testid="WarrantMissingTemplates">
      <FormLayout>
        <FormLayoutContent>
          <FormPanel title={title}>
            <FormButtons
              isEditing
              onClickCancel={onClickCancelClose}
              onClickClose={onClickCancelClose}
            />
          </FormPanel>
          <div className="callout">
            <Callout
              title={t('warrant.create.missingTemplate.title')}
              icon="error"
              intent="danger"
            >
              {t('warrant.create.missingTemplate.message')}
            </Callout>
          </div>
        </FormLayoutContent>
      </FormLayout>
    </div>
  );
};

export default WarrantMissingTemplates;
